export default function getFocalPointStyles(
    focalPoint:
        | "topLeft"
        | "topCenter"
        | "topRight"
        | "centerLeft"
        | "center"
        | "centerRight"
        | "bottomLeft"
        | "bottomCenter"
        | "bottomRight",
    cssProperty?: "background-position" | "object-position", // Toolkit Custom Code
) {
    const _cssProperty = cssProperty || "background-position"; // Toolkit Custom Code
    let focalPointStyles;
    switch (focalPoint) {
        case "topLeft":
            focalPointStyles = `${_cssProperty /* Toolkit Custom Code */}: left top;`;
            break;
        case "topCenter":
            focalPointStyles = `${_cssProperty /* Toolkit Custom Code */}: center top;`;
            break;
        case "topRight":
            focalPointStyles = `${_cssProperty /* Toolkit Custom Code */}: right top;`;
            break;
        case "centerLeft":
            focalPointStyles = `${_cssProperty /* Toolkit Custom Code */}: left center;`;
            break;
        case "center":
            focalPointStyles = `${_cssProperty /* Toolkit Custom Code */}: center center;`;
            break;
        case "centerRight":
            focalPointStyles = `${_cssProperty /* Toolkit Custom Code */}: right center;`;
            break;
        case "bottomLeft":
            focalPointStyles = `${_cssProperty /* Toolkit Custom Code */}: left bottom;`;
            break;
        case "bottomCenter":
            focalPointStyles = `${_cssProperty /* Toolkit Custom Code */}: center bottom;`;
            break;
        case "bottomRight":
            focalPointStyles = `${_cssProperty /* Toolkit Custom Code */}: right bottom;`;
            break;
    }

    return focalPointStyles;
}
